import { AbstractService } from "./abstract.service";

export class PartnerService extends AbstractService {
  static get entity() {
    return "proxy-gateway/gw-core/partner";
  }
  static get entityPartner() {
    return "nsh/partner/api/partners"
  }

  static get entity_partner() {
    return "nsh/partner/api/partners";
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static async getList(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async getCountPartner(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/count-search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async deletePartner(params) {
    try {
      const response = await this.callApi().delete(
        `${this.entity}`, {
          data: params
        }
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async getById(params) {
    try {
      const response = await this.callApi().get(
        `${this.entity}/${params}`
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async update(params) {
    try {
      const response = await this.callApi().patch(
        `${this.entity}/${params.id}`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async showRelationship(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/show-relationship`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async registerRelaitonship(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/register-relationship`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async dropRelaitonship(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/drop-relationship`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createNonPlatformPartner(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/non-platform`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createPlatformPartner(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async search(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/search`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateIMG(form, id) {
    try {
      const response = await this.callApi().post(
        `s3/image?folder=Next360_IMG&fileName=${id}`, form
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getSupplier() {
    try {
      const response = await await this.callApi().get(
        `${this.entityPartner}/customers`,
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async creatPartnerAtOrder(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_partner}/customers/create`,
        params
      );
      return this.responseWrapper(response, response.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getListPartners(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_partner}/customers`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // static async getListPartner(params) {
  //   try {
  //     console.log(AuthService.getBearer());
  //     const response = await axios.get(
  //       `${this.URL_GATEWAY}/${this.entity_partner}/customers`,
  //       { data: {
  //         ...params
  //       }},
  //       {
  //         headers: {
  //           Authorization: `Bearer ${AuthService.getBearer()}`
  //         }
  //       }
  //     )
  //     return response.data
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  static async getPartnerById(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entityPartner}/partner/detail`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
